<template>
    <div>
        <headerNav title="能不能吃" />
        
        <div>
            <van-search  @click="goto('/foodsearch')" disabled placeholder="请输入食物名称搜索" />
        </div>
        <div v-if="eatlist&&eatlist.length>0">
            <div class="mboxs">
                <div class="mbox" v-for="(item,index) in eatlist" :key="index" @click="goto('/food',item)">
                    <div class="mbox-img">
                        <img :src="$baseurl+item.img" />
                    </div>
                    <div class="mbox-wz">
                        {{item.title}}
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>

export default {
    
    data(){
        return{
            searchdata:{
                keyword:'输入食物名称搜索'
            },
            eatlist:[]
        }
    },
    created(){
        this.queryinfos();
    },
    methods:
    {
        queryinfos()
        {
            this.ajax.post('/api/services/app/PhoneEat/QueryAllEatCateList').then(x=>
            {
                this.eatlist=x.result;
            })
        },
        goto(url,item)
        {
            if(item)
            {
                 this.$router.push({path:url,query:{id:item.id}});
            }
            else
            {
                 this.$router.push({path:url});
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.mboxs{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items:center;
    text-align: center;
}
.mbox{
    margin-bottom: 10px;
    margin-top: 10px;
    width: 33%;
}
.mbox-img img{
    width: 40px;
    height: 40px;
}
.mbox-wz{
    font-size: 14px;
}

</style>